<template>
    <div class="p-6 bg-gray-100 min-h-screen">
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-bold">Gestión de Premios</h1>
        <button
          @click="abrirModal('crear')"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Crear Nuevo Premio
        </button>
      </div>
      <div class="flex gap-4 mb-6">
        <button
            @click="cambiarFiltro(null)"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
            Todos
        </button>
        <button
            @click="cambiarFiltro('1')"
            class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
            Activos
        </button>
        <button
            @click="cambiarFiltro('0')"
            class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
        >
            Inactivos
        </button>
        </div>

  
      <table class="table-auto w-full bg-white shadow rounded-lg">
        <thead class="bg-gray-200">
          <tr>
            <th class="px-4 py-2">ID</th>
            <th class="px-4 py-2">Premio</th>
            <th class="px-4 py-2">Permitido por Día</th>
            <th class="px-4 py-2">Permitido por Hora</th>
            <th class="px-4 py-2">Porcentaje de Acierto</th>
            <th class="px-4 py-2">Activo</th>
            <th class="px-4 py-2">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="premio in premios" :key="premio.id_premio">
            <td class="border px-4 py-2">{{ premio.id_premio }}</td>
            <td class="border px-4 py-2">{{ premio.premio }}</td>
            <td class="border px-4 py-2">{{ premio.permitido_por_dia }}</td>
            <td class="border px-4 py-2">{{ premio.permitido_por_hora }}</td>
            <td class="border px-4 py-2">{{ premio.porcentaje_acierto }}%</td>
            <td class="border px-4 py-2">{{ premio.activo === '1' ? 'Sí' : 'No' }}</td>
            <td class="border px-4 py-2 flex gap-2">
              <button
                @click="toggleActivo(premio)"
                class="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600"
              >
                {{ premio.activo === '1' ? 'Desactivar' : 'Activar' }}
              </button>
              <button
                @click="abrirModal('editar', premio)"
                class="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
              >
                <i class="fas fa-pencil-alt"></i> Editar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- Modal -->
      <div v-if="modalVisible" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div class="bg-white p-6 rounded shadow-lg w-full max-w-md">
          <h2 class="text-xl font-bold mb-4">
            {{ modalType === 'crear' ? 'Crear Nuevo Premio' : 'Editar Premio' }}
          </h2>
          <form @submit.prevent="modalType === 'crear' ? crearPremio() : editarPremio()">
            <div class="mb-4">
              <label class="block text-sm font-bold mb-1">Premio</label>
              <input v-model="formData.premio" type="text" class="w-full border px-3 py-2 rounded" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-bold mb-1">Permitido por Día</label>
              <input v-model.number="formData.permitido_por_dia" type="number" class="w-full border px-3 py-2 rounded" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-bold mb-1">Permitido por Hora</label>
              <input v-model.number="formData.permitido_por_hora" type="number" class="w-full border px-3 py-2 rounded" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-bold mb-1">Porcentaje de Acierto</label>
              <input v-model.number="formData.porcentaje_acierto" type="number" step="0.01" class="w-full border px-3 py-2 rounded" required />
            </div>
            <div class="flex justify-end gap-4">
              <button type="button" @click="cerrarModal" class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
                Cancelar
              </button>
              <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        premios: [],
        filtroActivo: null,
        modalVisible: false,
        modalType: "crear", // 'crear' o 'editar'
        formData: {
          id_premio: null,
          premio: "",
          permitido_por_dia: 0,
          permitido_por_hora: 0,
          porcentaje_acierto: 0.0,
        },
      };
    },
    methods: {
    //   async fetchPremios() {
    //     try {
    //       const { data } = await axios.get("/api/premios/listar");
    //       this.premios = data.data;
    //     } catch (error) {
    //       console.error("Error al listar premios:", error);
    //     }
    //   },
      async fetchPremios() {
            try {
            const { data } = await axios.get("/api/premios/listar", {
                params: { activo: this.filtroActivo },
            });
            this.premios = data.data;
            } catch (error) {
            console.error("Error al listar premios:", error);
            }
        },
        cambiarFiltro(activo) {
            this.filtroActivo = activo;
            this.fetchPremios();
        },
      abrirModal(tipo, premio = null) {
        this.modalType = tipo;
        this.modalVisible = true;
        if (tipo === "editar" && premio) {
          this.formData = { ...premio };
        } else {
          this.formData = {
            id_premio: null,
            premio: "",
            permitido_por_dia: 0,
            permitido_por_hora: 0,
            porcentaje_acierto: 0.0,
          };
        }
      },
      cerrarModal() {
        this.modalVisible = false;
      },
      async crearPremio() {
        try {
          await axios.post("/api/premios/agregar", this.formData);
          this.cerrarModal();
          this.fetchPremios();
        } catch (error) {
          console.error("Error al crear premio:", error);
        }
      },
      async editarPremio() {
        try {
          await axios.post(`/api/premios/actualizar/${this.formData.id_premio}`, this.formData);
          this.cerrarModal();
          this.fetchPremios();
        } catch (error) {
          console.error("Error al editar premio:", error);
        }
      },
      async toggleActivo(premio) {
        try {
          const nuevoEstado = premio.activo === "1" ? "0" : "1";
          await axios.post(`/api/premios/actualizar/${premio.id_premio}`, {
            activo: nuevoEstado,
          });
          this.fetchPremios();
        } catch (error) {
          console.error("Error al cambiar el estado activo:", error);
        }
      },
    },
    mounted() {
      this.fetchPremios();
    },
  };
  </script>
  
  <style scoped>
  .table-auto {
    border-collapse: collapse;
  }
  .table-auto th,
  .table-auto td {
    border: 1px solid #e5e7eb;
    padding: 0.75rem;
    text-align: left;
  }
  </style>
  